import {maxAllowedRoofElementLength} from "../../../constants/flatRoofConstants";
import {HBEWallDefaultThickness} from "../../../globals";

/*
* Relevant für Dächer mit einer Länge oberhalb *maxAllowedRoofElementLength*.
* Diese Spannweiten werden bis zur maximalen Elementlänge zusammengefasst und anschließend wird ein neues Element angefangen.
* Dabei ist zu beachten dass die End und Startpunkte immer mittig auf einem tragenden Element platziert sind.
* Zurückgegeben werden die zusammengefassten Sections die jeweiligen Spannweiten die diese enthalten sowie die Positionen auf denen diese stützt.
* Diese werden anschließen für die Berechnung der Segmente und Bestimmung der Einfeld/Mehrfeld Logik für die einzelnen Segmente.
* */
export class SectionsCalculator {
    constructor(spans, spanPositions, overhang, orientation) {
        this.spans = spans;
        this.spanPositions = spanPositions;
        this.overhang = overhang;
        this.orientation = orientation;
    }

    calculateSectionDepths() {
        //Aktuelle Spannweiten kopieren
        let spansWithOverhang = [...this.spans];

        //Auf erste und letzte Spannweite den Dachüberstand aufrechnen + jeweils eine halbe Wanddicke
        // (Spannpositionen liegen immer mittig auf einer Wand. Dadurch fehlt jeweils die Hälfte der ersten und letzten Wandstärke und wird hier wieder aufgerechnet)
        spansWithOverhang[0] += this.overhang + (0.5 * HBEWallDefaultThickness);
        spansWithOverhang[spansWithOverhang.length - 1] += this.overhang + (0.5 * HBEWallDefaultThickness);

        let sections1 = this.getSectionsFromSpans(spansWithOverhang, this.spanPositions);
        let sections2 = this.getSectionsFromSpans([...spansWithOverhang].reverse(), [...this.spanPositions].reverse()).reverse();

        return Math.max(sections1) > Math.max(sections2) ? sections2 : sections1;
    }

    getSectionsFromSpans(spans, spanPositions) {
        let sections = [];

        let currentSection = spans[0]; //Erste Spannweite als Ausgangswert
        let currentSpanPositions = [spanPositions[0], spanPositions[1]];
        let positionCount = 2; //Erstes Deckenstück liegt bereits auf 2 Wänden auf
        let includedSpans = [spans[0]]; //Speichern der einzelnen Spannweiten in einem Segment für spätere Deckenstärkenberechnung
        for (let i = 1; i < spans.length; i++) {
            if (currentSection + spans[i] < maxAllowedRoofElementLength) {
                //Wenn die neue Spannweite noch in die aktuelle Section passt diese aufnehmen und eine weitere Wandposition addieren
                currentSection += spans[i];
                includedSpans.push(spans[i]);
                currentSpanPositions.push(spanPositions[i + 1]);
                positionCount++;
            } else {
                //Sonst Section abschließen und mit dem aktuellen Element eine neue anfangen
                sections.push(currentSection);
                positionCount = 2;
                currentSection = spans[i];
                includedSpans = [spans[i]];
                currentSpanPositions = [spanPositions[i], spanPositions[i + 1]];
            }

            //Beim letzten Loop das aktuelle Element abschließen
            if (i === spans.length - 1) {
                sections.push(currentSection);
            }
        }

        return sections;
    }
}
